import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1380. 請求予定削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/billing_schedules/:billing_schedule_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  billing_schedule_id: number;
};

const destroyBillingSchedule = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/billing_schedules/${props.billing_schedule_id}`
  );
};

export const useDestroyBillingSchedule = () => {
  return useMutation({
    mutationFn: destroyBillingSchedule
  });
};